import { useEffect, useRef } from "react";
import { holdemInviteHomePath, holdemRegistrationAgentRid, holdemRegistrationPath,
  holdemRoomGamePath, isHoldemRegisteredPlayer } from "./HoldemRoomInvite";

export function useHoldemRoomInvite({ location, history, getPersist, setPersist, getGameUrl, hallOrigin }) {
  const handled = useRef("");
  const loaded = getPersist("dataLoaded");
  const userInfo = getPersist("user_info");
  useEffect(() => {
    if (!loaded) return;
    if (location.pathname !== "/home" && location.pathname !== "/") {
      handled.current = "";
      return;
    }
    const query = new URLSearchParams(location.search);
    // Leave legacy Tawla invitations to their existing handler.
    const returnPath = !query.has("aada_room_id") && !query.has("aada_subid") && holdemInviteHomePath(query);
    if (!returnPath) {
      handled.current = "";
      return;
    }
    const registered = isHoldemRegisteredPlayer(userInfo);
    const key = `${registered ? "game" : "register"}:${returnPath}`;
    if (handled.current === key) return;
    handled.current = key;
    const incoming = new URLSearchParams(returnPath.split("?")[1]);
    setPersist("agent_rid", holdemRegistrationAgentRid(returnPath, ""));
    setPersist("agent_from", incoming.get("f") || "");
    if (registered) {
      history.replace(holdemRoomGamePath(location.search, getGameUrl(3), hallOrigin));
    } else {
      setPersist("isLogin", false);
      setPersist("login_back_url", returnPath);
      history.replace(holdemRegistrationPath(returnPath));
    }
  }, [loaded, location.pathname, location.search, userInfo, getGameUrl, hallOrigin, history, setPersist]);
}
